import SearchByEmail from './searchByEmail';
import Main from '../common/Main/Main';
import { Wrapper } from './styles';

const OrphanAssigmentTabs = () => {

    return (
        <Main>
            <Wrapper>
                <SearchByEmail />
            </Wrapper>
        </Main>
    );
};

export default OrphanAssigmentTabs;
